module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-9.2e81862b.jpg";